import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 1 0 9 9","key":"svg-0"}]]

const IconLoader2 = createReactComponent('outline', 'loader-2', 'Loader2', __iconNode);

export default IconLoader2;